export default {

    en: "English",
  
    zh: "中文 (简体)"
  
  }